/**
 * Seed.Ajax
 */


define('Seed.Ajax',['jquery', 'Seed'], function ($, Seed) {
    'use strict';

    /**
     * Objet de gestion de requete Ajax
     */
    Seed.Ajax = {
        /**
         * Appel Ajax de type POST
         * @param {array} Param Tableaux de paramètres
         *   Contient : string url,
         *              string data,
         *              bool async,
         *              success : définition la fonction en cas de succès
         * @returns {nm$_Seed.Ajax.Seed_Ajax_L20.Seed.Ajax.Post.Response}
         */
        Post: function (Param) {
            if (Param["async"] !== true) {
                Param["async"] = false;
            }
            var Response;
            var loaderId = Seed.Ajax.startDelayedLoading();
            if (Param["xml"]) {
                Response = jQuery.ajax({
                    url: Param["url"],
                    data: Param["data"],
                    success: Param["success"],
                    type: "POST",
                    async: Param["async"],
                    error: function () {
                    }
                }).always(function () {
                    Seed.Ajax.stopDelayedLoading(loaderId);
                }).responseXML;
            } else if (Param["json"]) {
                Response = jQuery.ajax({
                    url: Param["url"],
                    data: Param["data"],
                    success: Param["success"],
                    type: "POST",
                    async: Param["async"],
                    error: function () {
                    }
                }).always(function () {
                    Seed.Ajax.stopDelayedLoading(loaderId);
                }).responseText;
                if (Param["async"] === false) {
                    Response = JSON.parse(Response);
                }
            } else {
                Response = jQuery.ajax({
                    url: Param["url"],
                    data: Param["data"],
                    success: Param["success"],
                    type: "POST",
                    async: Param["async"],
                    error: function () {
                    }
                }).always(function () {
                    Seed.Ajax.stopDelayedLoading(loaderId);
                }).responseText;
            }

            return Response;
        },
        /**
         * Appel Ajax de type GET
         * @param {array} Param Tableaux de paramètres
         *   Contient : string url,
         *              string data,
         *              bool async,
         *              success : définition la fonction en cas de succès
         * @returns {nm$_Seed.Ajax.Seed_Ajax_L19.Seed.Ajax.Get.Response}
         */
        Get: function (Param) {
            var timer = new Date();
            var time = timer.getTime();
            if (Param["async"] !== true) {
                Param["async"] = false;
            }

            var loaderId = Seed.Ajax.startDelayedLoading();
            var Response = jQuery.ajax({
                url: Param["url"],
                success: Param["success"],
                type: "GET",
                async: Param["async"],
                error: function () {
                    $("#load #message").text("Une erreur est survenue");
                    $("#load").css("background-color", "red");
                }
            }).always(function () {
                Seed.Ajax.stopDelayedLoading(loaderId);
            }).responseText;
            return Response;
        },
        loadingSucceed: function () {

            Seed.Ajax.loadingStop();
        },
        loadingStop: function () {
            $("#load").hide();
            document.body.style.cursor = "";
        },
        loadingStart: function () {
            $("#load #message").text("Traitement en cours...");
            $("#load").fadeIn('fast');
            document.body.style.cursor = "wait";
        },
        loadingFailed: function () {

            Seed.Ajax.loadingStop();
        },
        //Arrete et demarre timer
        startDelayedLoading: function () {
            var loaderId = setTimeout("Seed.Ajax.loadingStart();", 300);
            setTimeout("Seed.Ajax.loadingStop();", 1000);
            return loaderId;
        },
        //Arrete le timer
        stopDelayedLoading: function (loaderId) {
            clearTimeout(loaderId);
            Seed.Ajax.loadingStop();
        }
    };
});

